import { Wrapper } from '@klv/utils/wrapper';
import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/advancedIframe.module.css';

import type { IAdvancedIframe } from './types';

const heightClasses = {
  short: styles.short,
  medium: styles.medium,
  tall: styles.tall,
  fullScreen: styles.fullScreen,
};

export const AdvancedIframe = ({
  attributes = [],
  backgroundColor,
  className = '',
  contained = false,
  customPadding = { customPaddingBottom: 'md', customPaddingTop: 'md' },
  fadeIn = false,
  heightType,
  inset = false,
  padded = false,
  title,
  url,
}: IAdvancedIframe) => {
  const iframeAttributes = (attributes && attributes.reduce((attribute, { key, value }) => ({ ...attribute, [key]: value }), {})) || {};
  return (
    <Wrapper
      className={className}
      fadeIn={fadeIn ? .25 : 0}
      grid={true}
      backgroundColor={backgroundColor}
      customPadding={customPadding}
      contained={contained}
      inlinePadding={padded}
    >
      <iframe 
      title={title}
      src={url}
      className={generateClassName([styles.advancedIframe, heightClasses[heightType], inset ? styles.inset : ''])}
      {...iframeAttributes} />
    </Wrapper>
  );
};
